import { PAGINATION_DATA } from './../paginationData'
import gql from 'graphql-tag'

export const DATA_SIGNATURE = `
  id
  name
  position
  reports
  is_active
  status_text
  image_url
  image_type
  image_size
  image_name
  created_at
  image_full_url
`

export const GET_SIGNATURE_WITH_PAGINATION = gql`
  query signaturesWithPagination($first: Int!, $page: Int!) {
    signaturesWithPagination(first: $first, page: $page) {
      data {
        ${DATA_SIGNATURE}
      }
      ${PAGINATION_DATA}
    }
  }
`

export const SAVE = gql`
  mutation createSignature($input: SignatureInput!) {
    createSignature(input: $input) {
      ${DATA_SIGNATURE}
    }
  }
`

export const UPDATE = gql`
  mutation updateSignature($id: ID!, $imageChange: Boolean!, $input: SignatureInput!) {
    updateSignature(input: $input, id: $id, imageChange: $imageChange) {
      ${DATA_SIGNATURE}
    }
  }
`

export const DELETE = gql`
  mutation deleteSignature($id: ID!) {
    deleteSignature(id: $id) {
      id
    }
  }
`
